import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.min.css';

// 存储Viewer实例
let viewerInstance: Viewer | null = null;

export function imgViewer(src: string) {
  // 如果已经有查看器实例，先销毁
  if (viewerInstance) {
    viewerInstance.destroy();
    viewerInstance = null;
  }

  // 创建容器
  const container = document.createElement('div');
  container.classList.add('con');
  container.style.cssText = `
      display:none;
    // position: fixed;
    // left: 0;
    // right: 0;
    // top: 0;
    // bottom: 0;
    // width: 100%;
    // height: 100%;
    // z-index: 99999;
    // background: rgba(0, 0, 0, 0.7);
    // display: none;
    // align-items: center;
    // justify-content: center;
  `;

  // 创建图片元素
  const img = document.createElement('img');
  img.src = src;
  img.alt = '';
  img.style.cssText = 'max-width: 90%; max-height: 90%; object-fit: contain;';

  // 创建关闭按钮
  // const closeBtn = document.createElement('div');
  // closeBtn.className = 'img-viewer-close';
  // closeBtn.style.cssText =
  //   'position: absolute; top: 20px; right: 20px; z-index: 10; font-size: 28px; cursor: pointer;';
  // closeBtn.innerHTML = `<svg t="1753169224269" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4623" width="1em" height="1em"><path d="M1024 930.133333L930.133333 1024 512 605.866667 93.866667 1024 0 930.133333 418.133333 512 0 93.866667 93.866667 0 512 418.133333 930.133333 0 1024 93.866667 605.866667 512z" fill="#D8D8D8" p-id="4624"></path></svg>`;

  // 添加元素到容器
  container.appendChild(img);
  // container.appendChild(closeBtn);
  document.body.appendChild(container);

  // 淡入动画
  // fadeIn({
  //   element: container,
  //   originalDisplay: 'flex',
  // });

  // 初始化Viewer
  viewerInstance = new Viewer(img, {
    inline: false,
    backdrop: true,
    title: false,
    toolbar: false,
    tooltip: false,
    movable: true,
    zoomable: true,
    rotatable: false,
    scalable: true,
    transition: true,
    fullscreen: true,
    navbar: false,

    // 自定义显示和隐藏事件
    show: () => {
      // 已经通过fadeIn显示
    },
    hide: () => {
      // fadeOut({
      //   element: container,
      // });
      setTimeout(() => {
        if (viewerInstance) {
          viewerInstance.destroy();
          viewerInstance = null;
        }
        document.body.removeChild(container);
      }, 300);
    },
  });

  // 手动显示Viewer
  viewerInstance.show();

  // 关闭按钮事件
  // closeBtn.addEventListener('click', () => {
  //   if (viewerInstance) {
  //     viewerInstance.hide();
  //   }
  // });

  // 点击背景关闭
  // container.addEventListener('click', (e) => {
  //   if (e.target === container) {
  //     if (viewerInstance) {
  //       viewerInstance.hide();
  //     }
  //   }
  // });
}
